import { downloadFile } from "components/Common/download"
import { del, get, post, postFormData, putFormData } from "./AXIOS"
import { DOWNLOAD_POLICY, GET_COUNTRIES, POLICY, POLICY_UPDATES } from "./CONSTANTS"
import { requiresPolicyType, supportsSubNational } from "./subNationalService"

export const getPolicyUpdates = policyID => get(`${POLICY_UPDATES}/${policyID}`)

export const postPolicyUpdate = body => post(`${POLICY_UPDATES}`, body)

export const getPolicy = policyID => {
    return get(`${POLICY}${policyID}`);
}

export const getCountry = countryID => {
    return get(GET_COUNTRIES + countryID)
}

export const updatePolicy = (policyID, policyData, policyFile, isAGRAUser) => {
    const formData = new FormData();

    // Determine if country requires policy scope and sub-national fields
    const countryID = policyData.policy_request_body.country_id;

    const policy_update_data = {
        policy_update_request_body: {
            ...(policyData.policy_request_body.details && { details: policyData.policy_request_body.details }),
            supports_flagship: policyData.policy_request_body.supports_flagship,
            is_off_track: Boolean(policyData.policy_request_body.is_off_track),
            policy_scope: policyData.policy_request_body.policy_scope || "National",
            ...(supportsSubNational(countryID) && policyData.policy_request_body.policy_scope === "Sub-national" && 
                {sub_national_id: parseInt(policyData.policy_request_body.sub_national_id)}),
            name: policyData.policy_request_body.name,
            is_delayed: Boolean(policyData.policy_request_body.is_delayed),
            ...(requiresPolicyType(countryID) && {policy_type_id: policyData.policy_request_body.policy_type_id}),
            ...(isAGRAUser && {agra_strategy_version: policyData.policy_request_body.agra_strategy_version}),
            ...(isAGRAUser && {is_agra_supported: policyData.policy_request_body.is_agra_supported}),
        },
        // Move system_id to system_ids array
        system_ids: policyData.system_ids,
        partner_update_request_bodies: policyData.partner_request_bodies.map(partner => ({
            ...(partner.short_name && {short_name: partner.short_name}),
            long_name: partner.long_name || '',
            is_technical_expert: Boolean(partner.is_technical_expert),
            id: parseInt(partner.id)
        }))
    };
  
    // Append the JSON data
    formData.append('policy_update_data', JSON.stringify(policy_update_data));
    
    // Append the file if it exists
    if (policyFile instanceof File) {
        formData.append('policy_file', policyFile);
    }

    return putFormData(`${POLICY}${policyID}`, formData);
}

export const deletePolicyService = policyID => {
    return del(`${POLICY}${policyID}`);
} 

export const createPolicyService = (policyData, policyFile, isAGRAUser) => {
    const formData = new FormData();

    // Determine if country requires policy scope and sub-national fields
    const countryID = policyData.policy_request_body.country_id;

    const policy_create_data = {
        policy_create_request_body: {
            ...(policyData.policy_request_body.details && { details: policyData.policy_request_body.details }),
            supports_flagship: policyData.policy_request_body.supports_flagship,
            country_id: parseInt(policyData.policy_request_body.country_id),
            is_off_track: Boolean(policyData.policy_request_body.is_off_track),
            policy_scope: policyData.policy_request_body.policy_scope || "National",
            ...(supportsSubNational(countryID) && policyData.policy_request_body.policy_scope === "Sub-national" && 
                {sub_national_id: parseInt(policyData.policy_request_body.sub_national_id)}),
            name: policyData.policy_request_body.name,
            is_delayed: Boolean(policyData.policy_request_body.is_delayed),
            is_complete: policyData.policy_request_body.stage_id == 6 ? Boolean(policyData.policy_request_body.is_complete) : false,
            ...(requiresPolicyType(countryID) && {policy_type_id: parseInt(policyData.policy_request_body.policy_type_id)}),
            ...(isAGRAUser && {agra_strategy_version: policyData.policy_request_body.agra_strategy_version}),
            ...(isAGRAUser && {is_agra_supported: policyData.policy_request_body.is_agra_supported}),
            stage_id: parseInt(policyData.policy_request_body.stage_id),
        },
        // Move system_id to system_ids array
        system_ids: policyData.system_ids,
        partner_create_request_bodies: policyData.partner_request_bodies.map(partner => ({
            ...(partner.short_name && {short_name: partner.short_name}),
            long_name: partner.long_name || '',
            is_technical_expert: Boolean(partner.is_technical_expert),
            id: parseInt(partner.id)
        })),
        ...(!(policyData.policy_request_body.is_complete && policyData.policy_request_body.stage_id == 6) &&
        {current_stage_completed_milestones_ids: policyData.current_stage_completed_milestones_ids})
    };
  
    // Append the JSON data
    formData.append('policy_create_data', JSON.stringify(policy_create_data));
    
    // Append the file if it exists
    if (policyFile) {
        formData.append('policy_file', policyFile);
    }

    return postFormData(POLICY, formData);
}

export const downloadPolicy = (policyID, filename, fileNameWithExt, alert) => {
    get(DOWNLOAD_POLICY(policyID), { responseType: "blob" })
    .then(file => downloadFile(fileNameWithExt, filename, file))
    .catch(error => {
        alert();
        console.error('Error downloading the file:', error);
    });
}